// Tiny helpers for the library system.

export const KINDS = {
  document: { label: "Documentos", testid: "kind-document" },
  video: { label: "Vídeos", testid: "kind-video" },
  itinerary: { label: "Itinerários", testid: "kind-itinerary" },
};

// Embed-able iframe URL for YouTube/Vimeo video links.
export function getVideoEmbed(url) {
  if (!url) return null;
  try {
    const u = new URL(url);
    // YouTube
    if (/youtu\.be$/.test(u.hostname)) {
      const id = u.pathname.replace(/^\//, "").split(/[/?#]/)[0];
      return id ? `https://www.youtube.com/embed/${id}` : null;
    }
    if (/youtube\.com$/.test(u.hostname)) {
      const id = u.searchParams.get("v");
      if (id) return `https://www.youtube.com/embed/${id}`;
      const path = u.pathname.split("/").filter(Boolean);
      // /shorts/{id} or /embed/{id}
      if (["shorts", "embed", "live"].includes(path[0]) && path[1]) {
        return `https://www.youtube.com/embed/${path[1]}`;
      }
      return null;
    }
    // Vimeo
    if (/vimeo\.com$/.test(u.hostname)) {
      const id = u.pathname.split("/").filter(Boolean)[0];
      return id && /^\d+$/.test(id) ? `https://player.vimeo.com/video/${id}` : null;
    }
  } catch { /* ignore */ }
  return null;
}

// Naive plain-text → paragraphs renderer for itinerary bodies.
// Splits on blank lines to produce <p>; preserves single newlines as <br/>.
export function paragraphs(text) {
  if (!text) return [];
  return String(text).split(/\n\s*\n/).map((para) => para.trim()).filter(Boolean);
}
